import { TextField } from "@mui/material";
import clsx from "clsx";
import Text from "../../styleguide/Text";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment, { Moment } from "moment";
import { formInputClasses, formLabelClasses } from "./formControlStyles";

interface DatePicker {
  label?: string;
  placeholder?: string;
  handleChangeDate?: (newValue: Date | null) => void;
  value?: Date | string | null;
  disabled?: boolean;
  className?: string;
  withVerticalSpacer?: boolean;
  isRequired?: boolean;
  touched?: boolean;
  error?: string;
  textInputClassName?: string;
  dateFormat?: string;
  fullWith?: boolean;
  gutterBottom?: boolean;
  maxDate?: Date;
  minDate?: Date;
  withClearData?: boolean;
  currentTimezone?: string;
  withAmPm?: boolean;
  size?: any;
}

const DateTimePicker = ({
  label,
  placeholder,
  handleChangeDate,
  value,
  disabled,
  className,
  withVerticalSpacer,
  isRequired,
  textInputClassName,
  dateFormat = "DD/MM/YYYY HH:mm",
  fullWith = true,
  gutterBottom = true,
  maxDate,
  minDate,
  withClearData,
  touched,
  error,
  size = "medium",
  withAmPm = false,
}: DatePicker) => {
  const parsedValue = value ? moment(value) : null;
  const parsedMinDate = minDate ? moment(minDate) : undefined;
  const parsedMaxDate = maxDate ? moment(maxDate) : undefined;

  const handleChange = (newValue: Moment | null) => {
    if (withClearData) {
      handleChangeDate && handleChangeDate(newValue?.toDate() || null);
      return;
    }
    if (newValue) {
      handleChangeDate && handleChangeDate(newValue.toDate());
    }
  };

  return (
    <div
      className={`${fullWith ? "w-full" : ""} ${
        withVerticalSpacer ? "px-1" : ""
      } ${className}`}>
      <MuiDateTimePicker<Moment>
        componentsProps={{
          actionBar: {
            actions: withClearData ? ["clear"] : [],
          },
        }}
        inputFormat={dateFormat}
        value={parsedValue || null}
        disableMaskedInput
        onChange={handleChange}
        disabled={disabled}
        minDateTime={parsedMinDate}
        maxDateTime={parsedMaxDate}
        ampm={withAmPm ? true : false}
        className={clsx(formInputClasses, textInputClassName)}
        renderInput={(params) => (
          <div className={`flex flex-col ${gutterBottom ? "mb-7" : ""}`}>
            {label && (
              <label className={`${formLabelClasses} flex items-center`}>
                {label}
                {isRequired && <span className="ml-1 text-danger">*</span>}
              </label>
            )}
            <TextField
              sx={{
                "& fieldset": { border: "none" },
              }}
              size={size}
              variant="outlined"
              placeholder={placeholder}
              {...params}
              error={Boolean(error && touched)}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
                "aria-label": label ?? placeholder ?? "Selectează data și ora",
              }}
            />
          </div>
        )}
      />
      {touched && error && (
        <div className="pt-3">
          <Text variant="body1" role="alert" className="text-danger">
            {error}
          </Text>
        </div>
      )}
    </div>
  );
};

export default DateTimePicker;
